export default __webpack_public_path__ + "static/step-5-a916e0f0162001a4d79017f940f5bdb2.png";